import React, { ReactElement } from "react"
import { Box } from "@mui/material"
import Modal from "src/components/Modal"
import Text from "src/components/Text"
import Button from "src/components/Button"

interface ModalProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
}

export function UnstakeNFTModal({
  open,
  onClose,
  onConfirm,
}: ModalProps): ReactElement {
  return (
    <Modal title="Unstake NFTs before withdrawal" open={open} onClose={onClose}>
      <Text mt={3}>
        Please unstake your NFTs from the boosted pools before withdrawing xFER
        from vaults.
      </Text>
      <Box mt={3}>
        <Button fullWidth onClick={onConfirm}>
          Unstake NFT from boost page
        </Button>
        <Button kind="outline" onClick={onClose} fullWidth mt={1}>
          Cancel
        </Button>
      </Box>
    </Modal>
  )
}

export function WarnBoostModal({
  open,
  onClose,
  onConfirm,
}: ModalProps): ReactElement {
  return (
    <Modal title="Vault Withdrawal" open={open} onClose={onClose}>
      <Text mt={3}>
        Withdrawing from your xFER vault will decrease or remove boosted APR
        from your boosted pools. Are you sure you want to continue?
      </Text>
      <Box display="flex" mt={3}>
        <Button kind="outline" onClick={onClose} fullWidth>
          Cancel
        </Button>
        <Button fullWidth onClick={onConfirm} ml={1}>
          Yes, Continue
        </Button>
      </Box>
    </Modal>
  )
}
